import React, { lazy, memo, Suspense } from 'react';

const PdfViewer = lazy(() => import('./PdfViewer'));

const LazyPdfViewer = memo(({ fallback, ...props }) => {
    return (
        <Suspense fallback={fallback}>
            <PdfViewer {...props} />
        </Suspense>
    );
});

LazyPdfViewer.displayName = 'LazyPdfViewer';

export default LazyPdfViewer;
